import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {PopoverDetailsPage} from './popover-details';
import {TranslateModule} from "@ngx-translate/core";
import { CommonModule } from '@angular/common';
import {ComponentsModule} from "../../components/components.module";
import {NoResultsComponentModule} from "../../components/no-results/no-results.module";

@NgModule({
  declarations: [
    PopoverDetailsPage,
  ],
  imports: [
    IonicPageModule.forChild(PopoverDetailsPage),
    TranslateModule.forChild(),
    CommonModule,
    ComponentsModule,
    NoResultsComponentModule
  ],
})
export class PopoverDetailsPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/popover-details/popover-details.module.ts